export enum ItemID {
    // Weapons
    CandyCaneSpear = 'candy_cane_spear',
    WeakSword = 'weak_sword',
    
    // Icicle Daggers (crap to perfect)
    MeltingIcicleDagger = 'melting_icicle_dagger',
    FrostyIcicleDagger = 'frosty_icicle_dagger',
    SharpIcicleDagger = 'sharp_icicle_dagger',
    PerfectIcicleDagger = 'perfect_icicle_dagger',
    
    // Toy Hammers (broken to legendary)
    BrokenToyHammer = 'broken_toy_hammer',
    WoodenToyHammer = 'wooden_toy_hammer',
    SteelToyHammer = 'steel_toy_hammer',
    EnchantedToyHammer = 'enchanted_toy_hammer',
    NutcrackerHammer = 'nutcracker_hammer',
    HolidayHammer = 'holiday_hammer',
    
    // Christmas Wands (many varieties)
    SparklerWand = 'sparkler_wand',
    CandlestickWand = 'candlestick_wand',
    HollyWand = 'holly_wand',
    MistletoeWand = 'mistletoe_wand',
    PoinsettiaDagger = 'poinsettia_dagger',
    ChristmasTreeStaff = 'christmas_tree_staff',
    StarTopperWand = 'star_topper_wand',
    AngelWingsStaff = 'angel_wings_staff',
    JingleBellWand = 'jingle_bell_wand',
    GingerbreadWand = 'gingerbread_wand',
    FireworksWand = 'fireworks_wand',
    GrandFinaleWand = 'grand_finale_wand',
    
    // Christmas Lights Whips (tangled to magnificent)
    TangledChristmasLights = 'tangled_christmas_lights',
    OldChristmasLights = 'old_christmas_lights',
    BrightChristmasLights = 'bright_christmas_lights',
    LEDChristmasLights = 'led_christmas_lights',
    MagicalChristmasLights = 'magical_christmas_lights',

    // Consumables
    HotCocoa = 'hot_cocoa',
    Fruitcake = 'fruitcake',
    Marshmallow = 'marshmallow',
    CandyCane = 'candy_cane',
    
    // Snowball Projectiles
    Snowball = 'snowball',
    PackedSnowball = 'packed_snowball',
    Iceball = 'iceball',
    YellowSnowball = 'yellow_snowball',
    CoalSnowball = 'coal_snowball',
    
    // Ornament Grenades (fragile to explosive)
    CrackedOrnamentGrenade = 'cracked_ornament_grenade',
    GlassOrnamentGrenade = 'glass_ornament_grenade',
    SilverOrnamentGrenade = 'silver_ornament_grenade',
    GoldOrnamentGrenade = 'gold_ornament_grenade',
    PlatinumOrnamentGrenade = 'platinum_ornament_grenade',
    
    // Permanent Progression
    StarCookie = 'star_cookie',
    LiquidCourage = 'liquid_courage',
    
    // Christmas Scrolls (many varieties)
    ScrollOfEnchantment = 'scroll_of_enchantment',
    ScrollOfMapping = 'scroll_of_mapping',
    ScrollOfNiceList = 'scroll_of_nice_list',
    ScrollOfNaughtyList = 'scroll_of_naughty_list',
    ScrollOfChristmasSpirit = 'scroll_of_christmas_spirit',
    ScrollOfWinterWarmth = 'scroll_of_winter_warmth',
    ScrollOfReindeerCall = 'scroll_of_reindeer_call',
    ScrollOfElvenBlessing = 'scroll_of_elven_blessing',
    ScrollOfSantasSight = 'scroll_of_santas_sight',
    ScrollOfJingleAll = 'scroll_of_jingle_all',
    ScrollOfMistletoePortal = 'scroll_of_mistletoe_portal',
    ScrollOfSnowStorm = 'scroll_of_snow_storm',
    ScrollOfElvenCraftsmanship = 'scroll_of_elven_craftsmanship',
    
    // Unlabeled/Unidentified
    UnlabeledPotion = 'unlabeled_potion',
    WrappedGift = 'wrapped_gift',
    
    // Special Items
    ScrollOfSantasBlessing = 'scroll_of_santas_blessing',
    ChristmasWishBone = 'christmas_wish_bone',
    
    // New Year's Artifacts
    NewYearsClock = 'new_years_clock',
    ChampagneFlute = 'champagne_flute',
    CountdownCalendar = 'countdown_calendar',

    // Misc
    Gold = 'gold',
    ChristmasKey = 'christmas_key',
    SilverKey = 'silver_key',
    GoldKey = 'gold_key',
    BoneKey = 'bone_key',

    // Armor
    CozySweater = 'cozy_sweater',
    
    // Santa Suits (torn to magnificent)
    TornSantaSuit = 'torn_santa_suit',
    TatteredSantaSuit = 'tattered_santa_suit',
    ClassicSantaSuit = 'classic_santa_suit',
    LuxurySantaSuit = 'luxury_santa_suit',
    MagnificentSantaSuit = 'magnificent_santa_suit',
    
    // Ice Plate (melting to eternal)
    MeltingIcePlate = 'melting_ice_plate',
    ThinIcePlate = 'thin_ice_plate',
    ThickIcePlate = 'thick_ice_plate',
    EnchantedIcePlate = 'enchanted_ice_plate',
    EternalIcePlate = 'eternal_ice_plate',
    
    // Christmas Cloaks
    TatteredElfCloak = 'tattered_elf_cloak',
    ElfCloak = 'elf_cloak',
    MasterElfCloak = 'master_elf_cloak',
    ReindeerHideCloak = 'reindeer_hide_cloak',
    
    // Artifacts & Rings (many Christmas varieties)
    RingOfFrost = 'ring_of_frost',
    RingOfHaste = 'ring_of_haste',
    RingOfWarmth = 'ring_of_warmth',
    RingOfJingleBells = 'ring_of_jingle_bells',
    RingOfChristmasSpirit = 'ring_of_christmas_spirit',
    RingOfElvenGrace = 'ring_of_elven_grace',
    RingOfReindeerSpeed = 'ring_of_reindeer_speed',
    
    SnowGlobe = 'snow_globe',
    ReindeerBell = 'reindeer_bell',
    NaughtyList = 'naughty_list',
    ChristmasCandle = 'christmas_candle',
    MagicStocking = 'magic_stocking',
    ElvenCompass = 'elven_compass',
    FrozenHeart = 'frozen_heart',
    ChristmasWish = 'christmas_wish',
    MistletoeCharm = 'mistletoe_charm',
    AngelFeather = 'angel_feather',
    DriedWreath = 'dried_wreath',
    
    // Special Consumables
    ScrollOfRemoveCurse = 'scroll_of_remove_curse',
    AngelFeatherRevive = 'angel_feather_revive',
    ScrollOfIdentify = 'scroll_of_identify',
    PotionOfCureDisease = 'potion_of_cure_disease',
    ScrollOfTeleport = 'scroll_of_teleport',
    SantasCookie = 'santas_cookie',
    IcicleDagger = 'icicle_dagger',
    SantaSuit = 'santa_suit',
    ChristmasStar = 'christmas_star',
    GoldCoin = 'gold_coin',
    Coal = 'coal',
    KrampusHorn = 'krampus_horn',
    ScrollOfFrost = 'scroll_of_frost',
    
    // New Items
    TitaniumToyHammer = 'titanium_toy_hammer',
    HeavyPlateArmor = 'heavy_plate_armor',
    Gem = 'gem'
}
